const productBtns = document.querySelectorAll<HTMLButtonElement>(
  '.js-geoip-product-btn',
);

const showCells = (cell: HTMLTableCellElement) =>
  cell.classList.remove('d-none');

const hideCells = (cell: HTMLTableCellElement) => cell.classList.add('d-none');

if (productBtns.length > 0) {
  productBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      // Toggle cells
      const productType = btn.dataset.product;
      const cellsToShow = document.querySelectorAll<HTMLTableCellElement>(
        `.js-product-cell[data-product="${productType}"]`,
      );
      const cellsToHide = document.querySelectorAll<HTMLTableCellElement>(
        `.js-product-cell:not([data-product="${productType}"])`,
      );

      cellsToShow.forEach(showCells);
      cellsToHide.forEach(hideCells);

      // Toggle mobile purchase input product id
      const purchaseInput = document.querySelector<HTMLInputElement>(
        '.js-geoip-product-id-input',
      );
      if (purchaseInput) {
        purchaseInput.value = purchaseInput.dataset[productType || ''] || '';
      }

      // Update GTM data attributes on the form
      const purchaseForm = document.querySelector<HTMLFormElement>(
        '.js-gtm-add-to-cart',
      );
      if (purchaseForm && productType) {
        // Capitalize product type for GTM (country -> Country, city -> City)
        const capitalizedProduct =
          productType.charAt(0).toUpperCase() + productType.slice(1);
        purchaseForm.dataset.gtmProductId = capitalizedProduct;

        // Update unit price from stored data attribute
        const priceDataAttr = `gtmUnitPrice${capitalizedProduct}`;
        const unitPrice = purchaseForm.dataset[priceDataAttr];
        if (unitPrice) {
          purchaseForm.dataset.gtmUnitPrice = unitPrice;
        }
      }
    });
  });
}

// Pricing table toggle
const subscriptionToggle = document.querySelector<HTMLInputElement>(
  '.js-geoip-databases__price-toggle',
);
const oneTimeCells = document.querySelectorAll<HTMLTableCellElement>(
  '.js-geoip-subscription-cell[data-subscription="subscription-one-time"]',
);
const monthlyCells = document.querySelectorAll<HTMLTableCellElement>(
  '.js-geoip-subscription-cell[data-subscription="subscription-monthly"]',
);
const purchaseBtns =
  document.querySelectorAll<HTMLButtonElement>('.js-purchase-btn');
const opacityElements = document.querySelectorAll<HTMLElement>('.js-opacity');

const toggleCells = (cell: HTMLTableCellElement) => {
  cell.classList.toggle('d-none');
  cell.classList.toggle('d-table-cell');
};

const toggledHeading = document.querySelector<HTMLElement>(
  '.js-geoip-toggled-heading',
);

if (subscriptionToggle) {
  subscriptionToggle.addEventListener('change', () => {
    oneTimeCells.forEach(toggleCells);
    monthlyCells.forEach(toggleCells);
    opacityElements.forEach((element) => {
      element.classList.toggle('opacity-25');
    });
    purchaseBtns.forEach((btn) => {
      btn.disabled = subscriptionToggle.checked;
    });
    if (toggledHeading) {
      toggledHeading.textContent = subscriptionToggle.checked
        ? 'One-time'
        : 'Monthly';
    }
  });
}

const scrollToPlansEls = document.querySelectorAll('.js-scroll-to-plans');

scrollToPlansEls.forEach((el) => {
  el.addEventListener('click', () => {
    const plansSection = document.getElementById('geoip-databases-plans');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// Handle continent selection for pricing
const continentSelects = document.querySelectorAll('.js-continent-select');

continentSelects.forEach((select) => {
  select.addEventListener('change', () => {
    const selectedContinent = (select as HTMLSelectElement).value;
    const form = select.closest('form');
    const priceInput = form?.querySelector(
      '.js-continent-stripe-price-id',
    ) as HTMLInputElement;

    if (priceInput && selectedContinent) {
      // Convert product ID to camelCase data attribute name (City-Africa -> cityAfrica)
      const dataAttr = selectedContinent
        .toLowerCase()
        .replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
      const priceId = priceInput.dataset[dataAttr];

      if (priceId) {
        priceInput.value = priceId;
      }
    }
  });
});
